import React from 'react';
import styled from '@emotion/styled';
import {keyframes} from '@emotion/core';
const spin = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;
const Icon = styled.svg`
  g {
    transform-origin: 50% 50%;
    .active &,
    .idle & {
      animation: ${spin} 5s linear infinite;
    }
  }

  .cls-1,
  .cls-3 {
    fill: none;
  }

  .cls-1,
  .cls-2,
  .cls-3 {
    stroke: #fff;
    stroke-width: 2px;
  }

  .cls-1 {
    stroke-linecap: square;
  }
`;

export const WasteWaterTreatmentPlantIcon = () => {
  return (
    <Icon viewBox='0 0 72 72'>
      <g id='waste_icon' data-name='waste icon'>
        <path id='Line' className='cls-1' d='M36,4V68' />
        <circle id='Oval-5' className='cls-2' cx='36' cy='36' r='10' />
        <circle
          id='Oval-5-2'
          data-name='Oval-5'
          className='cls-3'
          cx='36'
          cy='36'
          r='35'
        />
      </g>
    </Icon>
  );
};
